export const getActiveHarvest = (harvestId) => ({ activeHarvests: { activeHarvestsList } }) =>
  activeHarvestsList.find(({ id }) => id === +harvestId);
